
const productConfig = {
  brandPrefix: "skore",
  productType: "Info",
  supportEmail: "support@ginylil.com",
  fullName: "skore Info"
};

export default productConfig;
